import { render, staticRenderFns } from "./TrucksWithAlertsPanel.vue?vue&type=template&id=21edac3a&scoped=true"
import script from "./TrucksWithAlertsPanel.vue?vue&type=script&lang=js"
export * from "./TrucksWithAlertsPanel.vue?vue&type=script&lang=js"
import style0 from "./TrucksWithAlertsPanel.vue?vue&type=style&index=0&id=21edac3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21edac3a",
  null
  
)

export default component.exports